import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import LandingPage from './components/LandingPage';
import BookingForm from './components/BookingForm';
import ConfirmationPopup from './components/ConfirmationPopup';

function App() {
  const [booking, setBooking] = useState(null);

  const handleBookingClose = () => {
    setBooking(null);
  };

  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/booking" element={<BookingForm setBooking={setBooking} />} />
        </Routes>
        {booking && <ConfirmationPopup booking={booking} onClose={handleBookingClose} />}
      </Router>
    </Provider>
  );
}

export default App;